import { Routes } from '@angular/router';
import { AuthGuard } from '@core/guards/auth.guard';
import { AppRoutes, ROUTE_PATHS } from '@shared/constants/app-routes';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/auth-redirect/auth-redirect.component').then(m => m.AuthRedirectComponent),
    pathMatch: 'full'
  },
  {
    path: ROUTE_PATHS[AppRoutes.LOGIN],
    loadComponent: () => import('./features/auth/auth.component').then(m => m.AuthComponent)
  },
  {
    path: ROUTE_PATHS[AppRoutes.TERMS_AND_CONDITIONS],
    loadComponent: () => import('./features/terms-and-conditions/terms-and-conditions.component').then(m => m.TermsAndConditionsComponent)
  },
  {
    path: ROUTE_PATHS[AppRoutes.HOME],
    loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent),
    canActivate: [AuthGuard]
  },
  {
    path: ROUTE_PATHS[AppRoutes.ENTRIES],
    loadComponent: () => import('./features/entries/entries.component').then(m => m.EntriesComponent),
    canActivate: [AuthGuard]
  },
  {
    path: ROUTE_PATHS[AppRoutes.INVITATIONS],
    loadComponent: () => import('./features/invitations/invitations.component').then(m => m.InvitationsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: ROUTE_PATHS[AppRoutes.CREATE_INVITATION],
    loadComponent: () => import('./features/create-invitation/create-invitation.component').then(m => m.CreateInvitationComponent),
    canActivate: [AuthGuard]
  },
  {
    path: ROUTE_PATHS[AppRoutes.INVITATION_DETAILS] + '/:id',
    loadComponent: () => import('./features/invitation-details/invitation-details.component').then(m => m.InvitationDetailsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: ROUTE_PATHS[AppRoutes.CHANGE_PASSWORD],
    loadComponent: () => import('./shared/components/change-password/change-password.component').then(m => m.ChangePasswordComponent),
    canActivate: [AuthGuard]
  },
  {
    path: ROUTE_PATHS[AppRoutes.PERSONAL_INFORMATION],
    loadComponent: () => import('./shared/components/personal-information/personal-information.component').then(m => m.PersonalInformationComponent),
    canActivate: [AuthGuard]
  },
  {
    path: ROUTE_PATHS[AppRoutes.EDIT_PERSONAL_INFO] + '/:field',
    loadComponent: () => import('./shared/components/edit-personal-info/edit-personal-info.component').then(m => m.EditPersonalInfoComponent),
    canActivate: [AuthGuard]
  },
  {
    path: ROUTE_PATHS[AppRoutes.UNAUTHORIZED],
    loadComponent: () => import('./shared/components/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent)
  },
  {
    path: '**',
    redirectTo: ROUTE_PATHS[AppRoutes.HOME]
  }
];

